const hasWindow = typeof window !== 'undefined'

export enum StorageKeys {
  profile = 'oxford-user-profile',
  lifestyle = 'oxford-user-lifestyle',
  filters = 'search-filters',
  dashboardFilters = 'oxford-dashboard-filters',
  wbac = 'oxford-sell-car',
  favouriteVehicle = 'oxford-favourite-vehicle',
  directFavouriteVehicle = 'oxford-direct-favourite-vehicle',
  compareRows = 'cinch-compare-rows',
  saveSearch = 'cinch-save-search',
  redirectUrl = 'cinch-account-confirm-redirectUrl',
  checkoutSessionId = 'cinch-checkout-tracking-id',
}

export const get = (key: StorageKeys): Partial<Cinch.UserProfileRequest> | any => {
  if (hasWindow) {
    return JSON.parse(window.sessionStorage.getItem(key) || '{}')
  }

  return {}
}

export const update = (key: StorageKeys, data: Partial<Cinch.UserProfileRequest> | any): void => {
  const current = get(key)

  if (hasWindow) {
    window.sessionStorage.setItem(key, JSON.stringify({ ...current, ...data }))
  }
}

export const clear = (key: StorageKeys) => {
  if (hasWindow) {
    window.sessionStorage.setItem(key, '')
  }
}
